
















import Vue, { PropType } from 'vue';
import contact from '@/modules/contact/contact';
import message, { Message } from '@/modules/contact/message';

// import buyer from '@/modules/buyer/buyer';
// import companyBuyer from '@/modules/buyer/company';
import {
  buyer,
  buyerCompany as companyBuyer,
} from 'mostra';

import {
  genDownloadImageUrlByImage,
  sizes,
} from '@/modules/image';

interface DataType {
  loading: boolean;
  buyerUID: string;
  buyerCID: string | null;
  exhibitorCID: string | null;
  name: string;
  company: string;
  unseen: boolean;
  unreplied: boolean;
  date: object | Date | null;
  lastMessage: Message | null;
  lastSenderCId: string;
  avatarImageSrc: string | null;
  // avatarImageSrcId: string;
  asReads: string[];
  asReadDateTimes: any[];
}

export default Vue.extend({
  name: 'GChatBuyerListItemContainer',
  props: {
    contactID: {
      type: String as PropType<string>,
    },
  },
  data(): DataType {
    return {
      loading: false,
      buyerUID: '',
      buyerCID: null,
      exhibitorCID: null,
      name: '',
      company: '',
      unseen: false,
      unreplied: false,
      date: null,
      lastMessage: null,
      lastSenderCId: '',
      avatarImageSrc: '',
      // avatarImageSrcId: '',
      asReads: [],
      asReadDateTimes: [],
    };
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
    async fetchContact() {
      try {
        this.loading = true;
        const res = await contact.load(this.contactID);
        if (!res || !res.data.buyer) { throw Error('can not get contact'); }

        this.buyerCID = res.data.buyer;
        this.exhibitorCID = res.data.exhibitor;
        this.asReads = res.data.asReads;
        this.asReadDateTimes = res.data.asReadDateTimes;
      } catch (err: any) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    async fetchBuyer() {
      if (!this.buyerCID) return;
      try {
        this.loading = true;
        const resBuyerCompany = await companyBuyer.load(this.buyerCID);
        if (!resBuyerCompany || !resBuyerCompany.data.owner) {
          throw Error('cant get buyerCompany');
        }

        this.buyerUID = resBuyerCompany.data.owner;
        const resBuyer = await buyer.load(this.buyerUID);
        if (!resBuyer) throw Error('cant get buyer');

        this.name = resBuyer.data.name;
        this.company = resBuyerCompany.data.name;

        this.avatarImageSrc = await genDownloadImageUrlByImage(
          sizes.x512,
          resBuyer.data.profileImage,
        );
        // if (!resBuyer.data.profileImage || !resBuyer.data.profileImage.id)
        // this.avatarImageSrc = resBuyer.data.profileImage.id;
      } catch (err: any) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    async fetchLastMessage() {
      try {
        if (!this.contactID || !this.buyerCID || !this.exhibitorCID) {
          throw new Error('datas is null:1');
        }
        this.loading = true;
        const res = await message.loadsByContactId(this.contactID, this.buyerCID, this.exhibitorCID);
        if (!res) return;
        if (!res.length) return;
        const lastMessage = res[res.length - 1];
        this.lastMessage = lastMessage;
        this.date = lastMessage.data.registeredDate;
        if (!lastMessage.data.senderCID) return;
        this.lastSenderCId = lastMessage.data.senderCID;
      } catch (err: any) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    checkAsRead() {
      if (!this.lastMessage) {
        this.unseen = false;
        return;
      }
      const uid = this.$auth.uid;
      const seen = this.asReads.includes(uid);
      if (seen) {
        this.unseen = false;
        return;
      }
      this.unseen = true;
    },
    checUnreplied() {
      const uid = this.$auth.uid;
      const seen = this.asReads.includes(uid);
      const isBuyerLast = this.lastSenderCId === this.buyerCID;
      if (seen && isBuyerLast) {
        this.unreplied = true;
        return;
      }
      this.unreplied = false;
    },
  },
  async mounted() {
    await this.fetchContact();
    await this.fetchLastMessage();
    await this.fetchBuyer();
    // await this.fetchAvatar();
    this.checkAsRead();
    this.checUnreplied();
  },
});
